// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { CREATE_ORGANIZATION } from "./action";

export function canCreateOrganization(scope: Scope): boolean {
  return scope.iamActions.includes(CREATE_ORGANIZATION);
}
